// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"614":"c181a30d","787":"7ee2ad37"}[chunkId] + ".chunk.js";
};